export default {
  path: '/homeold',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'homeold',
  component: () => import( /* webpackChunkName: "home" */'./index')
};
